import { ErrorCircleIcon } from "@assets/icons";
import { StatusButtons } from "@components/ui";
import { useTranslation } from "react-i18next";

export function ErrorComponent({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) {
  const { t } = useTranslation("common");

  return (
    <section className="container flex flex-1 items-center justify-center">
      <div className="flex max-w-sm flex-col items-center gap-7 text-center">
        <ErrorCircleIcon className="size-32 md:size-56" />

        <div className="flex flex-col gap-4">
          <h1 className="text-xl font-bold text-dark md:text-2xl">
            {title || t("genericErrorTitle")}
          </h1>
          {description && (
            <p className="text-sm text-secondary md:text-base">{description}</p>
          )}
        </div>

        <StatusButtons />
      </div>
    </section>
  );
}
